module.exports = __webpack_public_path__ + "9817f8c3998d6bec3c14904139eb9358.svg";